import angular from 'angular';

(function () {
    'use strict';
    var core = angular.module('app.principal');

    core.constant(
        'PRINCIPAL',
        Object.freeze({
            menuCreate: [
                {
                    step: 1,
                    order: 0,
                    display: true,
                    label: 'principal.menu.detail',
                    link: 'nogo',
                    active: true,
                },
                {
                    step: 2,
                    order: 5,
                    display: true,
                    label: 'principal.menu.config_portal',
                    link: 'nogo',
                    disabled: true,
                },
                {
                    step: 3,
                    order: 10,
                    display: true,
                    label: 'principal.menu.param_kiss',
                    link: 'nogo',
                    disabled: true,
                },
                {
                    step: 4,
                    order: 40,
                    display: true,
                    label: 'principal.menu.param_lad_ext',
                    link: 'nogo',
                    disabled: true,
                },
            ],
            menuConsult: [
                {
                    id: 'detail',
                    order: 0,
                    display: true,
                    label: 'principal.menu.detail',
                    link: 'app.principal.consult.detail',
                    showOk: true,
                },
                {
                    id: 'configportal',
                    order: 5,
                    display: true,
                    label: 'principal.menu.config_portal',
                    link: 'app.principal.consult.configportal',
                    showOk: true,
                },
                {
                    id: 'personaliseportal',
                    order: 8,
                    display: true,
                    label: 'principal.menu.personalise_portal',
                    link: 'app.principal.consult.personaliseportal',
                    showOk: true,
                },
                {
                    id: 'kiss',
                    order: 10,
                    display: true,
                    label: 'principal.menu.param_kiss',
                    link: 'app.principal.consult.kiss',
                    showOk: true,
                },
                {
                    id: 'client',
                    order: 20,
                    display: true,
                    label: 'principal.menu.param_buyer',
                    link: 'app.principal.consult.buyer',
                    showOk: true,
                },
                {
                    id: 'offre-api',
                    order: 25,
                    display: true,
                    label: 'principal.menu.offre_api',
                    link: 'app.principal.consult.offreApi',
                    showOk: true,
                },
                {
                    id: 'acquittal',
                    order: 27,
                    display: true,
                    label: 'principal.menu.acquittal',
                    link: 'app.principal.consult.acquittal',
                    showOk: true,
                },
                {
                    id: 'epdf',
                    order: 30,
                    display: true,
                    label: 'principal.menu.param_lad_ext',
                    link: 'app.principal.consult.epdf',
                    showOk: true,
                },
                {
                    id: 'managing-referential',
                    order: 35,
                    display: true,
                    label: 'principal.menu.referential',
                    link: 'app.principal.consult.referential',
                    showOk: true,
                },
                {
                    id: 'documentary-space',
                    order: 30,
                    display: true,
                    label: 'principal.menu.documentary_space',
                    link: 'app.principal.consult.documentaryspace',
                    showOk: true,
                },
                {
                    id: 'invoice-param',
                    order: 40,
                    display: true,
                    label: 'principal.menu.invoice_param',
                    link: 'app.principal.consult.invoiceparam',
                    showOk: true,
                },
                {
                    id: 'invoice-statements',
                    order: 41,
                    display: true,
                    label: 'principal.menu.invoice_statements',
                    link: 'app.principal.consult.invoicestatements',
                    showOk: true,
                },
                {
                    id: 'order-param',
                    order: 42,
                    display: true,
                    label: 'principal.menu.order_param',
                    link: 'app.principal.consult.orderparam',
                    showOk: true,
                },
                {
                    id: 'response-param',
                    order: 43,
                    display: true,
                    label: 'principal.menu.response_param',
                    link: 'app.principal.consult.responseparam',
                    showOk: true,
                },
                {
                    id: 'desadv-param',
                    order: 44,
                    display: true,
                    label: 'principal.menu.desadv_param',
                    link: 'app.principal.consult.desadvparam',
                    showOk: true,
                },
                {
                    id: 'recadv-param',
                    order: 45,
                    display: true,
                    label: 'principal.menu.recadv_param',
                    link: 'app.principal.consult.recadvparam',
                    showOk: true,
                },
                {
                    id: 'companies',
                    order: 50,
                    display: true,
                    label: 'principal.menu.companies',
                    link: 'app.principal.consult.listcompanies',
                    showOk: true,
                },
                {
                    id: 'sellers',
                    order: 60,
                    display: true,
                    label: 'principal.menu.sellers',
                    link: 'app.principal.consult.listsellers',
                    showOk: true,
                },
                {
                    id: 'buyers',
                    order: 65,
                    display: true,
                    label: 'principal.menu.buyers',
                    link: 'app.principal.consult.listbuyers',
                    showOk: false,
                },
                {
                    id: 'containers',
                    order: 70,
                    display: true,
                    label: 'principal.menu.containers',
                    link: 'app.principal.consult.containers',
                    showOk: false,
                },
                {
                    id: 'group',
                    order: 73,
                    display: true,
                    label: 'principal.menu.group',
                    link: 'app.principal.consult.group',
                },
                {
                    id: 'users',
                    order: 74,
                    display: true,
                    label: 'principal.menu.users',
                    link: 'app.principal.consult.users',
                },
                {
                    id: 'divider1',
                    order: 75,
                    display: true,
                    showOk: false,
                },
                {
                    id: 'checkconfig',
                    order: 76,
                    display: true,
                    label: 'principal.menu.check_configuration',
                    link: 'app.principal.consult.check_config',
                    showOk: false,
                    authorization: 'SUPPORT',
                },
                {
                    id: 'exportconfig',
                    order: 77,
                    display: true,
                    label: 'principal.menu.export_configuration',
                    link: 'app.principal.consult.export_config',
                    showOk: false,
                    authorization: 'CONFIGURATOR',
                },
                {
                    id: 'reports',
                    order: 80,
                    display: true,
                    label: 'principal.menu.reports',
                    link: 'app.principal.consult.reports',
                    showOk: false,
                },
            ],
            plateforms: ['GIS', 'PASREL', 'ALL'],
            ladTypes: ['AUTO', 'EXTERNAL', 'MYINVOICE', 'ALL'],
            searchableLadTypes: ['AUTO', 'EXTERNAL', 'ALL'],
            dematModes: ['PAPER', 'AUDIT', 'SIGNED_PDF', 'ALL'],
            invitationType: ['MAIL', 'EDITIQUE', 'FICHIER'],
            emailTemplateType: ['DEFAULT', 'CUSTOM'],
            langs: ['fr', 'en', 'en_US', 'de', 'es', 'it', 'nl', 'pt'],
            socFr: ['FR', 'GF', 'TF', 'YT', 'NC', 'BL', 'MF', 'PM', 'GP', 'MQ', 'PF', 'RE', 'WF'],
            reportFrequencies: ['DAILY', 'WEEKLY', 'MONTHLY', 'NEVER'],
            invitationReportErrorFrequencies: ['DAILY', 'WEEKLY', 'MONTHLY'],
            invitedSellersReferentialSendingFrequencies: ['DAILY', 'WEEKLY', 'MONTHLY'],
            acquittalStatuses: [
                { key: 'OK_SENDER_PAYMENT_RECEIVED', title: 'Encaissée (OK_SENDER_PAYMENT_RECEIVED)', formats: ['default', 'cdar'] },
                { key: 'OK_RECIPIENT_COMPLETED', title: 'Complétée (OK_RECIPIENT_COMPLETED)', formats: ['default'] },
                { key: 'OK_SENDER_COMPLETED', title: 'Complétée Fournisseur (OK_SENDER_COMPLETED)', formats: ['default', 'cdar'] },
                { key: 'OK_RECIPIENT_RECEIVED', title: 'Reçue/Acquittée (OK_RECIPIENT_RECEIVED)', formats: ['default'] },
                { key: 'OK_RECIPIENT_INTEGRATED', title: 'Intégrée (OK_RECIPIENT_INTEGRATED)', formats: ['default'] },
                { key: 'OK_RECIPIENT_CHECKED', title: 'Déposée (OK_RECIPIENT_CHECKED)', formats: ['default'] },
                { key: 'OK_RECIPIENT_PROCESSING', title: 'En cours de traitement (OK_RECIPIENT_PROCESSING)', formats: ['default', 'cdar'] },
                { key: 'OK_RECIPIENT_NOT_INTEGRATED', title: 'Non intégrée (OK_RECIPIENT_NOT_INTEGRATED)', formats: ['default', 'cdar'] },
                { key: 'OK_RECIPIENT_RECORDED', title: 'Comptabilisée (OK_RECIPIENT_RECORDED)', formats: ['default'] },
                { key: 'OK_RECIPIENT_NOT_MATCHED', title: 'Non Rapprochée (OK_RECIPIENT_NOT_MATCHED)', formats: ['default'] },
                { key: 'OK_RECIPIENT_NOTIFIED', title: 'Remise au comptable (OK_RECIPIENT_NOTIFIED)', formats: ['default', 'cdar'] },
                { key: 'OK_RECIPIENT_NOT_APPROVED', title: 'Non approuvée (OK_RECIPIENT_NOT_APPROVED)', formats: ['default', 'cdar'] },
                { key: 'OK_RECIPIENT_DISAGREED', title: 'En litige (OK_RECIPIENT_DISAGREED)', formats: ['default', 'cdar'] },
                { key: 'OK_RECIPIENT_BLOCKED', title: 'Bloquée (OK_RECIPIENT_BLOCKED)', formats: ['default', 'cdar'] },
                { key: 'OK_RECIPIENT_TO_BE_PAID', title: 'Bon à payer (OK_RECIPIENT_TO_BE_PAID)', formats: ['default', 'cdar'] },
                { key: 'OK_RECIPIENT_FOR_PAYMENT', title: 'Mise en paiement (OK_RECIPIENT_FOR_PAYMENT)', formats: ['default', 'cdar'] },
                { key: 'OK_RECIPIENT_PART_TO_BE_PAID', title: 'Approuvée partiellement (OK_RECIPIENT_PART_TO_BE_PAID)', formats: ['default', 'cdar'] },
                { key: 'OK_RECIPIENT_PAID', title: 'Réglée (OK_RECIPIENT_PAID)', formats: ['default', 'cdar'] },
                { key: 'OK_RECIPIENT_CONTROL', title: 'Contrôlée (OK_RECIPIENT_CONTROL)', formats: ['default', 'cdar'] },
                { key: 'ERROR_RECIPIENT_DEMAT_REJECTED', title: 'Rejetée (ERROR_RECIPIENT_DEMAT_REJECTED)', formats: ['default', 'cdar'] },
                { key: 'BLOCKED_FOR_RECIPIENT', title: 'Prise en charge (BLOCKED_FOR_RECIPIENT)', formats: ['default', 'cdar'] },
                { key: 'ERROR_REJECTED_FOR_RECIPIENT', title: 'Refusée (ERROR_REJECTED_FOR_RECIPIENT)', formats: ['default', 'cdar'] },
                { key: 'OK_ARCHIVED_FOR_SENDER', title: 'Émise (OK_ARCHIVED_FOR_SENDER)', formats: ['default'] },
                { key: 'OK_CLEARANCE_ACCEPTED', title: 'Déposée (OK_CLEARANCE_ACCEPTED)', formats: ['default'] },
                { key: 'ERROR_CLEARANCE_REJECTED', title: 'Rejetée (ERROR_CLEARANCE_REJECTED)', formats: ['cdar'] },
            ],
            pagination: {
                defaultPageSize: 10,
                defaultSort: [
                    {
                        direction: 'DESC',
                        property: 'idPrincipal',
                    },
                ],
            },
            listPrincipalColumn: [],
            grid: {},
            emailTemplateUploadResult: {
                messageLogo: '1 logo importé',
                messageFichier: 'Génération email',
                type: ['invitation', 'relance'],
                libelleLang: 'pour la langue :',
            },
            profil: {
                buyer: 'BUYER',
                seller: 'SELLER',
                buyerSeller: 'BUYER_SELLER',
            },
            invBuyServices: ['INVOICE', 'ORDER', 'DOCUMENTATION_SPACE'],
        })
    );
    core.constant(
        'TYPEGROUPE',
        Object.freeze({
            all: 'ALL',
            standard: 'STANDARD',
            invitedSeller: 'INVITED_SELLER',
        })
    );
    core.constant(
        'IMPORTTYPE',
        Object.freeze({
            buyer_sub_entities_relations: 'BUYER_SUB_ENTITIES_RELATIONS',
            sellers: 'SELLERS',
            buyers: 'BUYERS',
            buyers_relations: 'BUYERS_RELATIONS',
            relations: 'RELATIONS',
        })
    );
    core.constant(
        'DEMATMODE',
        Object.freeze({
            INVOICE: 'EDI simple',
            EDI_INVOICE: 'EDI fiscal',
            GENERIC: 'Générique',
            PAPER_INVOICE: 'Papier',
            ECOPY_INVOICE: 'Papier copie fiable',
            SIGNED_INVOICE: 'PDF signé',
            AUDIT_INVOICE: "Piste d'audit",
            STATEMENT: 'Relevé',
            DEFAULT: 'Par défaut',
        })
    );
})();
